// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import * as FeedbackAPI from "./feedback.mjs";
import { Feedback } from "./feedback.mjs";
import * as StepsMessagesAPI from "./messages.mjs";
import { Messages } from "./messages.mjs";
import * as MetricsAPI from "./metrics.mjs";
import { Metrics } from "./metrics.mjs";
import * as TraceAPI from "./trace.mjs";
import { Trace } from "./trace.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Steps extends APIResource {
    constructor() {
        super(...arguments);
        this.metrics = new MetricsAPI.Metrics(this._client);
        this.trace = new TraceAPI.Trace(this._client);
        this.feedback = new FeedbackAPI.Feedback(this._client);
        this.messages = new StepsMessagesAPI.Messages(this._client);
    }
    /**
     * Get a step by ID.
     */
    retrieve(stepID, options) {
        return this._client.get(path `/v1/steps/${stepID}`, options);
    }
    /**
     * List steps with optional pagination and date filters.
     */
    list(query = {}, options) {
        return this._client.getAPIList('/v1/steps/', (ArrayPage), { query, ...options });
    }
}
Steps.Metrics = Metrics;
Steps.Trace = Trace;
Steps.Feedback = Feedback;
Steps.Messages = Messages;
//# sourceMappingURL=steps.mjs.map